module.exports = __webpack_public_path__ + "img/Jigsaw&.b09702c9.svg";